import { memo } from 'react';
import { Tooltip } from '@mui/material';
import PushPin from '@mui/icons-material/PushPin';
import { LANE_PIN_COLOR } from './stickyLanes.styles';

import PropTypes from 'prop-types';

const LanePinIndicator = ({ show, username, className, color = LANE_PIN_COLOR, fontSize = 14 }) => {
    if (!show) return null;

    return (
        <Tooltip title={username ? `Lane pinned by ${username}` : 'Lane pinned'} placement="top">
            <span className={className} style={{ display: 'inline-flex', alignItems: 'center' }}>
                <PushPin sx={{ fontSize, color }} />
            </span>
        </Tooltip>
    );
};

LanePinIndicator.propTypes = {
    show: PropTypes.bool,
    username: PropTypes.string,
    className: PropTypes.string,
    color: PropTypes.string,
    fontSize: PropTypes.number,
};

export default memo(LanePinIndicator);
